import { CreateBatchResponseType } from '@app/code/src/types/flowcode.types'
import {
  CreateFlowcodeStateType,
  FlowcodeColorOptionType
} from '@app/common/src/types/createFlowcode.types'
import { FcGeneratorOptions } from '@dtx-company/flowcode-generator-browser/src'

export interface CreateFlowcodeReturnType {
  flowcodeOptions: FcGeneratorOptions
  flowcodeBatch: CreateBatchResponseType
}

export type CreateAutoDesignedCode = () => Promise<CreateFlowcodeReturnType>

export type CreateCode = () => Promise<CreateFlowcodeReturnType>

export enum CreateFlowcodeFormField {
  // FILE
  File = 'file',
  // VENMO
  VenmoAmount = 'venmo.amount',
  VenmoRecipients = 'venmo.recipients',
  VenmoNote = 'venmo.note',
  // EMAIL
  Email = 'email.email',
  EmailSubject = 'email.subject',
  EmailBody = 'email.body',
  // SMS
  SMSPhoneNumber = 'sms.phoneNumber',
  SMSMessage = 'sms.message',
  // PHONE
  Phone = 'phone',
  // WIFI
  WiFiSSID = 'wifi.ssid',
  WiFiPassword = 'wifi.password',
  WifiHidden = 'wifi.hidden',
  WifiAuthenticationType = 'wifi.authenticationType',
  // SOCIAL MEDIA - temporarily using this name since it's shared on mobile
  SocialMediaId = 'subtypeId',
  // LINK
  LINK = 'link',
  Nickname = 'nickname'
}

export interface CreateFlowcodeStateActions {
  setTemplate: (template: CreateFlowcodeStateType['template']) => void
  setColor: (color: FlowcodeColorOptionType) => void
  setTheme: (theme: CreateFlowcodeStateType['theme']) => void
  setDownloadFileType: (fileType: CreateFlowcodeStateType['downloadFileType']) => void
  toggleTransparency: (transparent: CreateFlowcodeStateType['transparent']) => void
  setDestination: (destination: CreateFlowcodeStateType['destination']) => void
  setLoadingCreateFlowcode: (loading: CreateFlowcodeStateType['loadingCreateFlowcode']) => void
  setBorder: (border: CreateFlowcodeStateType['border']) => void
  setShortURL: (url: CreateFlowcodeStateType['shortURL']) => void
  setBorderShape: (shape: CreateFlowcodeStateType['borderShape']) => void
  setRotate: (rotate: CreateFlowcodeStateType['rotate']) => void
}
